export default function generateFlightSearchKey(departureAirportCode: string | undefined, arrivalAirportCode: string | undefined) {
  if (!departureAirportCode || !arrivalAirportCode) {
    return undefined
  }

  const airports = [departureAirportCode, arrivalAirportCode]

  return airports.sort().join('-')
}
